import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  AuditMediaSummary,
  requestGetMediaByIds
} from "./getMediaByIds.request";

const useGetMediaByIds = (
  ids: string[],
  options?: QueryOptions<AuditMediaSummary[], ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["audit-log", "media-by-ids", ids],
    queryFn: async () => await requestGetMediaByIds(ids),
    enabled: ids.length > 0,
    onError: toastServerError,
    ...options
  });

  return { media: data ?? [], ...rest };
};

export default useGetMediaByIds;
